import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';

@Component({
  name: 'bpc-display-field-button',
  components: {},
})
export default class DisplayFieldButton extends mixins(AbstractDisplayField) {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  onClick() {
    this.$emit('on-click', { field: this.fieldConfig.key, item: this.item });
  }
}
